import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextareaComponent } from './textarea.component';
import { FormFieldModule } from '../form-field/form-field.module';

@NgModule({
  declarations: [TextareaComponent],
  exports: [TextareaComponent, FormFieldModule],
  imports: [CommonModule, FormFieldModule],
})
export class TextareaModule {}
